import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const HomeIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="M7.942 3.933 5.386 1.377 5.009 1l-.377.377-2.556 2.556L1 5.009l.377.377.7-.7v3.779h5.865V4.687l.681.681L9 4.991 7.942 3.933Zm-.533 4h-4.8V4.154l2.4-2.4 2.4 2.4v3.779Z" />
        </SvgIcon>
    );
};
